import React, { useEffect, useMemo, useRef, useState } from 'react'
import useSound from 'use-sound'

import neomdeposit from '../../../assets/sounds/neomdeposit.mp3'
import rainbowdeposit from '../../../assets/sounds/rainbowdeposit.mp3'
import onicdeposit from '../../../assets/sounds/onicdeposit.mp3'
import thebitdepo from '../../../assets/sounds/thebitdepo.mp3'
import message2 from '../../../assets/sounds/message2.mp3'

// 기존 입금 + 출금신청 -> 변경 SoundRepeat2 : 입금신청 , SoundRepeat7 : 출금신청
const SoundRepeat2 = ({ text = '' }) => {

	const [refresh, setRefresh] = useState(false);

	let sound = useMemo(() => {
		let sound = message2;
		if (process.env.REACT_APP_NAME === 'NEOM') {
			sound = neomdeposit
		} else if (process.env.REACT_APP_NAME === 'RAINBOW') {
			sound = rainbowdeposit;
		} else if (process.env.REACT_APP_NAME === 'ONIC') {
			sound = onicdeposit
		} else if( process.env.REACT_APP_NAME === 'THEBIT') {
			sound = thebitdepo
		}else { // 기본
			sound = message2
		}
		console.log("SOUND", process.env.REACT_APP_NAME);

		return sound
	}, [process.env.REACT_APP_NAME]);


	const [play, { stop }] = useSound(sound, { interrupt: true, volume:process.env.REACT_APP_NAME === 'ONIC'?0.6:1  });

	useEffect(() => {
		console.log("PLAY2");
		play({
			forceSoundEnabled: true,
		});
		setTimeout(() => {
			setRefresh(!refresh);
		}, 60*1000*5);
	}, [refresh]);

	useEffect(() => {
		setTimeout(() => {
			setRefresh(!refresh);
		}, 200);

		return () => {
			stop();
		};
	}, [stop]);

	return <>{''}</>
}
export default SoundRepeat2
